// StartupRegistration.jsx
import React from "react";

export default function StartupRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Startup Registration.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Startup Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Startup Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides structured support for Startup
            Registration, helping founders choose the right legal form and meet
            core regulatory requirements for launching a compliant startup.
          </p>
          <p className="text-gray-700">
            From entity selection and registration to aligning with applicable
            tax and regulatory norms, the team assists startups in building a
            legally sound foundation so founders can focus on growth,
            investment, and innovation.
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1181406/pexels-photo-1181406.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Startup founders planning registration and compliance"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Startup Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks supports startups in collating and organizing
              all primary documents needed for business registration and
              associated startup-related compliances.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Business incorporation documents (MoA, AoA, partnership deed,
                  LLP agreement or similar, as applicable)
                </li>
                <li>PAN card of the entity or founder, as applicable</li>
                <li>
                  Identity and address proof of founders/directors/partners
                </li>
                <li>Registered office address proof</li>
                <li>
                  Basic business profile or pitch deck, if needed for
                  registrations or schemes
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The approach is tailored for early-stage ventures, combining legal
              clarity with startup-centric guidance to support long-term
              scalability and investor readiness.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Startup-Focused Advisory
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance aligned with startup needs, including choice of
                  entity, founder agreements, and key registrations relevant for
                  fundraising and growth.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Compliance-Driven Approach
                </h3>
                <p className="text-gray-700 text-sm">
                  Focus on accurate documentation, statutory registrations, and
                  ongoing legal obligations to reduce compliance risks from the
                  beginning.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Consistent support for queries, filings, and formalities, so
                  founders have a dependable professional partner throughout the
                  registration journey.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
